











































import { Component, Prop, Vue } from 'vue-property-decorator';
import PerformanceWidget from '@/components/organisms/Performance/PerformanceWidget/index.vue';
import NightlyRatesCheckbox
  from '@/components/organisms/Performance/PerformanceWidget/PerformanceWidgetNightlyRates/NightlyRatesCheckbox/index.vue';
import PerformanceTrendDiagram from '@/components/organisms/Performance/PerformanceTrendDiagram/index.vue';
import NightlyRatesLine
  from '@/components/organisms/Performance/PerformanceWidget/PerformanceWidgetNightlyRates/NightlyRatesLine/index.vue';

@Component({
  name: 'PerformanceWidgetRegionOccupancyTrend',
  components: {
    PerformanceTrendDiagram,
    PerformanceWidget,
    NightlyRatesCheckbox,
    NightlyRatesLine,
  },
})
export default class PerformanceWidgetRegionOccupancyTrend extends Vue {
  @Prop() protected loading!: any;

  @Prop() protected values!: any;

  @Prop() protected unit!: any;

  @Prop() protected avgMarketOccupancy!: any;

  @Prop() protected hasError!: boolean;

  protected types: any = {
    marketOccupancy: true,
    avgMarketOccupancy: true,
  };

  protected typeTitles: any = {
    marketOccupancy: 'Occupancy Rate',
    avgMarketOccupancy: 'Avg. Occupancy',
  };

  protected get curveStyles(): any {
    return {
      marketOccupancy: { color: '#4077F6', style: 'solid', curveType: 'curveLinear' },
      avgMarketOccupancy: {
        type: 'line', color: '#4077F6', style: 'dotted', unit: '%', value: this.avgMarketOccupancy,
      },
    };
  }
}
